import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem, AccordionPanel,
  Box,
  Button,
  Divider,
  Flex, HStack,
  Text
} from '@chakra-ui/react';
import PropTypes from 'prop-types';

import LogoBox from '../../../components/Header/LogoBox';
import loginBackground from '../../../loginBackground.png';
import boxStyles from '../../../styles/boxStyles';
import colors from '../../../styles/theme/foundation/colors';

const CertHolderUserPage = props => {
  const history = useHistory();

  return (
    <Box
      backgroundImage={loginBackground}
      backgroundPosition="center"
      backgroundSize="cover"
      h="100vh"
      position="relative"
      w="100vw"
    >
      <Box
        alignItems="center"
        display="flex"
        h="100%"
        justifyContent="center"
        p={6}
      >
        <Box
          bgColor={colors.white}
          borderRadius="sm"
          boxShadow={boxStyles.boxShadow}
          mx="auto"
          my="auto"
          p={8}
          w="650px"
        >
          <Text
            mb={4}
            textAlign="center"
            textStyle="bodyXxl500"
          >
            This email address has already been registered as a user to a paid PINS account.
          </Text>

          <HStack justifyContent="center">
            <Button
              mb={4}
              variant="secondary"
              w="40%"
              onClick={() => history.push('verify')}
            >
              Back to Verification Page
            </Button>

            <Button
              mb={4}
              variant="primary"
              w="40%"
              onClick={() => {
                window.location.href = `${window.location.origin}/v2/login`;
              }}
            >
              Go to Certificate Holder Login
            </Button>
          </HStack>

          <Flex align="center" my={6}>
            <Divider borderColor="gray.600" />
            <Text color="gray.600" fontSize="sm" mx={3}>
              FAQ
            </Text>
            <Divider borderColor="gray.600" />
          </Flex>

          <Accordion allowToggle>
            <AccordionItem border="none">
              <h2>
                <AccordionButton px={0}>
                  <Box flex="1" fontWeight="semibold" textAlign="left">
                    I know, but I want to submit a certificate into PINS.  How can I do this?
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4} px={0}>
                <Text mb={3} textAlign="left" textStyle="bodyXl">
                  You can!  First, login to PINS using the Certificate Holder Login page.
                  Certificates can be submitted from any Insured Profile Page using the Policies Section Gear Icon.
                  Click the gear icon, then select &#34;Create Certificate&#34;.
                </Text>
              </AccordionPanel>
            </AccordionItem>

            <AccordionItem border="none">
              <h2>
                <AccordionButton px={0}>
                  <Box flex="1" fontWeight="semibold" textAlign="left">
                    I use to be a PINS user, but I have left that company and am now an agent/broker.  How can I get into PINS to add a certificate?
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4} px={0}>
                <Text textAlign="left" textStyle="bodyXl">
                  Please contact our support team at support@pinsadvantage.com and we can remove your email address from the PINS account.
                  If you do not have the time, you can always submit using a different email address.
                </Text>
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        </Box>
      </Box>
    </Box>
  );
};

CertHolderUserPage.propTypes = {};

export default CertHolderUserPage;
